import type { I18nPrefix } from '../../i18n/prefix';

export const I18N_PAGE = 'features:pricing.pages.price_editor_page' satisfies I18nPrefix;
export const I18N_DETAIL_PAGE = 'features:pricing.pages.variant_pricing_page' satisfies I18nPrefix;
export const I18N_COMPONENTS = 'features:pricing.components' satisfies I18nPrefix;

export const PRICE_EDITOR_PATH = '/pricing/editor';

const DOCS_BASE = 'https://docs.sparklayer.io';

export const DOCS_URLS = {
  priceEditor: `${DOCS_BASE}/price-editor`,
  quantityPricing: `${DOCS_BASE}/quantity-pricing#unit-of-measure-pricing`,
} as const;
